module.exports = __webpack_public_path__ + "static/media/lys.1fe439b0.png";